import { Routes } from '@angular/router';
import { Error404Component } from './components/errors/error 404/error-404.component';

export const appRoutes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () => import('@ls-commons/login').then(r => r.loginRoutes),
    // loadChildren: () =>
    //   import('./../../../../lib/shared/login/src/index').then(
    //     r => r.loginRoutes
    //   ),
    data: {
      title: $localize`:@@login.title:Iniciar Sesión`,
      backgroundList: [
        // 'assets/img/background/1920/karlis-reimanis-wEU9ZLGMpC8-unsplash.jpg',
        // 'assets/img/background/1920/ben-mccloskey-HL503uGSwuY-unsplash.jpg',
        // 'assets/img/background/1920/boliviainteligente-AgSZuXX3GCU-unsplash.jpg',
        // 'assets/img/background/1920/2482203.jpg',
        // 'assets/img/background/1920/zeng-yili-QWKAv65uhQs-unsplash.jpg',
        // 'assets/img/background/1920/r-architecture-2gDwlIim3Uw-unsplash.jpg',
        // 'assets/img/background/1920/breno-assis-r3WAWU5Fi5Q-unsplash.jpg',
        // 'assets/img/background/1920/avi-werde-hHz4yrvxwlA-unsplash.jpg',
      ],
      logo_url: 'assets/img/logo_blanco_1024_new.png',
      loginGoogle: false,
      linkBack: '/login',
    },
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.routes').then(m => m.dashboardRoutes),
  },

  { path: 'error-404', component: Error404Component },
  { path: '**', redirectTo: 'error-404' },
];
